import {
  Checkbox,
} from "@mui/material"
import { styled } from "@mui/styles"
import UncheckedSvg from "../icons/checkbox-unchecked.svg"
import UncheckedRedSvg from "../icons/checkbox-unchecked-red.svg"
import CheckedSvg from "../icons/checkbox-checked.svg"
import IndeterminateSvg from "../icons/indeterminate-checkbox.svg"
import { ReactComponent as CheckedDisabledSvg } from "../icons/checkbox-checked-disabled.svg"
import { ReactComponent as UncheckedDisabledSvg } from "../icons/checkbox-unchecked-disabled.svg"

const UncheckedIcon = styled('span')(({ theme }) => ({
  borderRadius: "2px",
  width: "20px",
  height: "20px",
  backgroundColor: '#FFF',
  backgroundImage: `url(${UncheckedSvg})`,
}))

const CheckedIcon = styled(UncheckedIcon)({
  backgroundImage: `url(${CheckedSvg})`,
})

const UncheckedRedIcon = styled('span')(({ theme }) => ({
  borderRadius: "2px",
  width: "20px",
  height: "20px",
  backgroundColor: '#FFF',
  backgroundImage: `url(${UncheckedRedSvg})`,
}))

const CustomIndeterminateCheckBoxIcon = styled('span')(({ theme }) => ({
  borderRadius: "2px",
  width: "20px",
  height: "20px",
  backgroundColor: '#FFF',
  backgroundImage: `url(${IndeterminateSvg})`,
}))

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      checkedIcon={!props.disabled ? <CheckedIcon /> : <CheckedDisabledSvg />}
      indeterminateIcon={<CustomIndeterminateCheckBoxIcon />}
      icon={!props.disabled ? props?.error ? <UncheckedRedIcon /> : <UncheckedIcon /> : <UncheckedDisabledSvg />}
      inputProps={{ 'aria-label': 'Checkbox' }}
      {...props}
    />
  );
}
export default CustomCheckbox;
